import React from 'react';

export const DownloadIcon = () =>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24">
    <path fill="#79ADA3" fillRule="evenodd" d="M35.9804688,31.7304688 L56.0195312,31.7304688 L56.0195312,34.25 L35.9804688,34.25 L35.9804688,31.7304688 Z M50.9804688,24.2304688 L46,29.2695312 L41.0195312,24.2304688 L44.7695312,24.2304688 L44.7695312,11.75 L47.2304688,11.75 L47.2304688,24.2304688 L50.9804688,24.2304688 Z" transform="translate(-35 -11)"/>
  </svg>;
